import { Box, SimpleGrid, Stat, StatLabel, StatNumber } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface Props {
  mandatoryCount: number;
  voluntaryActiveCount: number;
  voluntaryTotalCount: number;
}

export const ExclusionGroundsSummary = ({ mandatoryCount, voluntaryActiveCount, voluntaryTotalCount }: Props) => {
  const { t } = useTranslation();
  const totalActive = mandatoryCount + voluntaryActiveCount;
  const total = mandatoryCount + voluntaryTotalCount;

  return (
    <SimpleGrid columns={{ base: 1, md: 3 }} spacing="4" mb="4">
      <Box borderWidth="1px" borderRadius="lg" borderColor="smBorder" p="4" bg="smQuaternarySoft">
        <Stat>
          <StatNumber fontSize="xl" color="smQuaternary">{mandatoryCount}</StatNumber>
          <StatLabel fontSize="xs" color="smMuted">{t("mandatory active")}</StatLabel>
        </Stat>
      </Box>
      <Box borderWidth="1px" borderRadius="lg" borderColor="smBorder" p="4" bg="smSecondarySoft">
        <Stat>
          <StatNumber fontSize="xl" color="smSecondary">{voluntaryActiveCount} / {voluntaryTotalCount}</StatNumber>
          <StatLabel fontSize="xs" color="smMuted">{t("voluntary active")}</StatLabel>
        </Stat>
      </Box>
      <Box borderWidth="1px" borderRadius="lg" borderColor="smBorder" p="4" bg="smPrimarySofter">
        <Stat>
          <StatNumber fontSize="xl" color="smPrimary">{totalActive} / {total}</StatNumber>
          <StatLabel fontSize="xs" color="smMuted">{t("total active")}</StatLabel>
        </Stat>
      </Box>
    </SimpleGrid>
  );
};
